export const DEFAULT_WHITEBOARD = 'whiteboardBlack';
export const CHAR_BANK_ID = 'char-bank';
export const CHAR_BANK_2_ID = 'char-bank-2';